// extracted by mini-css-extract-plugin
export default {"navigation":"navbar_navigation__I2Rbr","navigationMenu":"navbar_navigationMenu__zb5Hf","navBarTitle":"navbar_navBarTitle__WmHtw","navItem":"navbar_navItem__NhknZ"};